export interface CountryType {
    code: string;
    label: string;
    phone: string;
    nickname?: string;
    suggested?: boolean;
  }
  
  export const countries: readonly CountryType[] = [
    {
      code: "AD",
      label: "Andorra",
      phone: "376",
      nickname: "The Pyrenean Country",
    },
    {
      code: "AE",
      label: "United Arab Emirates",
      phone: "971",
      nickname: "UAE",
    },
    {
      code: "AF",
      label: "Afghanistan",
      phone: "93",
      nickname: "Afghan",
    },
    {
      code: "AG",
      label: "Antigua and Barbuda",
      phone: "1268",
      nickname: "Twin Islands",
    },
    {
      code: "AI",
      label: "Anguilla",
      phone: "1264",
      nickname: "The Friendly Island",
    },
    {
      code: "AL",
      label: "Albania",
      phone: "355",
      nickname: "Land of the Eagles",
    },
    {
      code: "AM",
      label: "Armenia",
      phone: "374",
      nickname: "Hayastan",
    },
    {
      code: "AO",
      label: "Angola",
      phone: "244",
      nickname: "Land of the Brave",
    },
    // NOTE: Antarctica (AQ) REMOVED because libphonenumber-js doesn't support it
  
    {
      code: "AR",
      label: "Argentina",
      phone: "54",
      nickname: "Land of Silver",
    },
    {
      code: "AS",
      label: "American Samoa",
      phone: "1684",
      nickname: "The Heart of Polynesia",
    },
    {
      code: "AT",
      label: "Austria",
      phone: "43",
      nickname: "The Alpine Republic",
    },
    {
      code: "AU",
      label: "Australia",
      phone: "61",
      nickname: "Down Under",
      suggested: true,
    },
    {
      code: "AW",
      label: "Aruba",
      phone: "297",
      nickname: "One Happy Island",
    },
    {
      code: "AX",
      label: "Alland Islands",
      phone: "358",
      nickname: "The Baltic Archipelago",
    },
    {
      code: "AZ",
      label: "Azerbaijan",
      phone: "994",
      nickname: "Land of Fire",
    },
    {
      code: "BA",
      label: "Bosnia and Herzegovina",
      phone: "387",
      nickname: "Heart-Shaped Land",
    },
    {
      code: "BB",
      label: "Barbados",
      phone: "1246",
      nickname: "Bim",
    },
    {
      code: "BD",
      label: "Bangladesh",
      phone: "880",
      nickname: "The Land of the Bengalis",
    },
    {
      code: "BE",
      label: "Belgium",
      phone: "32",
      nickname: "The Flat Country",
    },
    {
      code: "BF",
      label: "Burkina Faso",
      phone: "226",
      nickname: "Land of Upright People",
    },
    {
      code: "BG",
      label: "Bulgaria",
      phone: "359",
      nickname: "Land of Roses",
    },
    {
      code: "BH",
      label: "Bahrain",
      phone: "973",
      nickname: "The Two Seas",
    },
    {
      code: "BI",
      label: "Burundi",
      phone: "257",
      nickname: "The Heart of Africa",
    },
    {
      code: "BJ",
      label: "Benin",
      phone: "229",
      nickname: "The Birthplace of Voodoo",
    },
    {
      code: "BL",
      label: "Saint Barthelemy",
      phone: "590",
      nickname: "St. Barts",
    },
    {
      code: "BM",
      label: "Bermuda",
      phone: "1441",
      nickname: "The Bermuda Triangle",
    },
    {
      code: "BN",
      label: "Brunei Darussalam",
      phone: "673",
      nickname: "The Abode of Peace",
    },
    {
      code: "BO",
      label: "Bolivia",
      phone: "591",
      nickname: "The Rooftop of the World",
    },
    {
      code: "BR",
      label: "Brazil",
      phone: "55",
      nickname: "The Giant of South America",
    },
    {
      code: "BS",
      label: "Bahamas",
      phone: "1242",
      nickname: "The Islands of the Bahamas",
    },
    {
      code: "BT",
      label: "Bhutan",
      phone: "975",
      nickname: "Land of the Thunder Dragon",
    },
    {
      code: "BV",
      label: "Bouvet Island",
      phone: "47",
      nickname: "The Uninhabited Island",
    },
    {
      code: "BW",
      label: "Botswana",
      phone: "267",
      nickname: "Land of Diamonds",
    },
    {
      code: "BY",
      label: "Belarus",
      phone: "375",
      nickname: "White Russia",
    },
    {
      code: "BZ",
      label: "Belize",
      phone: "501",
      nickname: "The Jewel",
    },
    {
      code: "CA",
      label: "Canada",
      phone: "1",
      nickname: "The Great White North",
      suggested: true,
    },
    {
      code: "CC",
      label: "Cocos (Keeling) Islands",
      phone: "61",
      nickname: "The Coconut Islands",
    },
    {
      code: "CD",
      label: "Congo, Democratic Republic of the",
      phone: "243",
      nickname: "DRC",
    },
    {
      code: "CF",
      label: "Central African Republic",
      phone: "236",
      nickname: "CAR",
    },
    {
      code: "CG",
      label: "Congo, Republic of the",
      phone: "242",
      nickname: "The Congo",
    },
    {
      code: "CH",
      label: "Switzerland",
      phone: "41",
      nickname: "The Alpine Nation",
    },
    {
      code: "CI",
      label: "Cote d'Ivoire",
      phone: "225",
      nickname: "Ivory Coast",
    },
    {
      code: "CK",
      label: "Cook Islands",
      phone: "682",
      nickname: "The Paradise of the South Pacific",
    },
    {
      code: "CL",
      label: "Chile",
      phone: "56",
      nickname: "Land of Poets",
    },
    {
      code: "CM",
      label: "Cameroon",
      phone: "237",
      nickname: "Africa in Miniature",
    },
    {
      code: "CN",
      label: "China",
      phone: "86",
      nickname: "The Middle Kingdom",
    },
    {
      code: "CO",
      label: "Colombia",
      phone: "57",
      nickname: "Land of Coffee",
    },
    {
      code: "CR",
      label: "Costa Rica",
      phone: "506",
      nickname: "The Rich Coast",
    },
    {
      code: "CU",
      label: "Cuba",
      phone: "53",
      nickname: "Pearl of the Antilles",
    },
    {
      code: "CV",
      label: "Cape Verde",
      phone: "238",
      nickname: "The Archipelago of Ten",
    },
    {
      code: "CW",
      label: "Curacao",
      phone: "599",
      nickname: "Curaçao",
    },
    {
      code: "CX",
      label: "Christmas Island",
      phone: "61",
      nickname: "The Island of the Crabs",
    },
    {
      code: "CY",
      label: "Cyprus",
      phone: "357",
      nickname: "The Island of Aphrodite",
    },
    {
      code: "CZ",
      label: "Czech Republic",
      phone: "420",
      nickname: "The Heart of Europe",
    },
    {
      code: "DE",
      label: "Germany",
      phone: "49",
      nickname: "The Land of Poets and Thinkers",
      suggested: true,
    },
    {
      code: "DJ",
      label: "Djibouti",
      phone: "253",
      nickname: "The Pearl of the Gulf of Tadjoura",
    },
    {
      code: "DK",
      label: "Denmark",
      phone: "45",
      nickname: "The Kingdom of Denmark",
    },
    {
      code: "DM",
      label: "Dominica",
      phone: "1767",
      nickname: "The Nature Island",
    },
    {
      code: "DO",
      label: "Dominican Republic",
      phone: "1809",
      nickname: "The DR",
    },
    {
      code: "DZ",
      label: "Algeria",
      phone: "213",
      nickname: "Land of the Berbers",
    },
    {
      code: "EC",
      label: "Ecuador",
      phone: "593",
      nickname: "Middle of the World",
    },
    {
      code: "EE",
      label: "Estonia",
      phone: "372",
      nickname: "The Baltic Tiger",
    },
    {
      code: "EG",
      label: "Egypt",
      phone: "20",
      nickname: "The Land of the Pharaohs",
    },
    {
      code: "EH",
      label: "Western Sahara",
      phone: "212",
      nickname: "The Desert Nation",
    },
    {
      code: "ER",
      label: "Eritrea",
      phone: "291",
      nickname: "The North Korea of Africa",
    },
    {
      code: "ES",
      label: "Spain",
      phone: "34",
      nickname: "La Roja",
    },
    {
      code: "ET",
      label: "Ethiopia",
      phone: "251",
      nickname: "The Horn of Africa",
    },
    {
      code: "FI",
      label: "Finland",
      phone: "358",
      nickname: "The Land of a Thousand Lakes",
    },
    {
      code: "FJ",
      label: "Fiji",
      phone: "679",
      nickname: "The Soft Coral Capital of the World",
    },
    {
      code: "FK",
      label: "Falkland Islands (Malvinas)",
      phone: "500",
      nickname: "The Falklands",
    },
    {
      code: "FM",
      label: "Micronesia, Federated States of",
      phone: "691",
      nickname: "The Federated States",
    },
    {
      code: "FO",
      label: "Faroe Islands",
      phone: "298",
      nickname: "The Sheep Islands",
    },
    {
      code: "FR",
      label: "France",
      phone: "33",
      nickname: "The Hexagon",
      suggested: true,
    },
    {
      code: "GA",
      label: "Gabon",
      phone: "241",
      nickname: "The Land of the Surf",
    },
    {
      code: "GB",
      label: "United Kingdom",
      phone: "44",
      nickname: "Great Britain",
    },
    {
      code: "GD",
      label: "Grenada",
      phone: "1473",
      nickname: "The Spice Island",
    },
    {
      code: "GE",
      label: "Georgia",
      phone: "995",
      nickname: "The Cradle of Wine",
    },
    {
      code: "GF",
      label: "French Guiana",
      phone: "594",
      nickname: "Cayenne",
    },
    {
      code: "GG",
      label: "Guernsey",
      phone: "44",
      nickname: "The Bailiwick of Guernsey",
    },
    {
      code: "GH",
      label: "Ghana",
      phone: "233",
      nickname: "The Gold Coast",
    },
    {
      code: "GI",
      label: "Gibraltar",
      phone: "350",
      nickname: "The Rock",
    },
    {
      code: "GL",
      label: "Greenland",
      phone: "299",
      nickname: "Kalaallit Nunaat",
    },
    {
      code: "GM",
      label: "Gambia",
      phone: "220",
      nickname: "The Smiling Coast of Africa",
    },
    {
      code: "GN",
      label: "Guinea",
      phone: "224",
      nickname: "Guinea-Conakry",
    },
    {
      code: "GP",
      label: "Guadeloupe",
      phone: "590",
      nickname: "The Butterfly Island",
    },
    {
      code: "GQ",
      label: "Equatorial Guinea",
      phone: "240",
      nickname: "The Oil Giant of Africa",
    },
    {
      code: "GR",
      label: "Greece",
      phone: "30",
      nickname: "The Hellenic Republic",
    },
    {
      code: "GT",
      label: "Guatemala",
      phone: "502",
      nickname: "The Land of Eternal Spring",
    },
    {
      code: "GU",
      label: "Guam",
      phone: "1671",
      nickname: "Where America’s Day Begins",
    },
    {
      code: "GW",
      label: "Guinea-Bissau",
      phone: "245",
      nickname: "Land of a Thousand Rivers",
    },
    {
      code: "GY",
      label: "Guyana",
      phone: "592",
      nickname: "The Land of Many Waters",
    },
    {
      code: "HK",
      label: "Hong Kong",
      phone: "852",
      nickname: "Pearl of the Orient",
    },
    {
      code: "HM",
      label: "Heard Island and McDonald Islands",
      phone: "672",
      nickname: "The Frozen Wilderness",
    },
    {
      code: "HN",
      label: "Honduras",
      phone: "504",
      nickname: "The Banana Republic",
    },
    {
      code: "HR",
      label: "Croatia",
      phone: "385",
      nickname: "The Land of a Thousand Islands",
    },
    {
      code: "HT",
      label: "Haiti",
      phone: "509",
      nickname: "La Perle des Antilles",
    },
    {
      code: "HU",
      label: "Hungary",
      phone: "36",
      nickname: "The Breadbasket of Europe",
    },
    {
      code: "ID",
      label: "Indonesia",
      phone: "62",
      nickname: "The Emerald of the Equator",
    },
    {
      code: "IE",
      label: "Ireland",
      phone: "353",
      nickname: "The Emerald Isle",
    },
    {
      code: "IL",
      label: "Israel",
      phone: "972",
      nickname: "The Holy Land",
    },
    {
      code: "IM",
      label: "Isle of Man",
      phone: "44",
      nickname: "Ellan Vannin",
    },
    {
      code: "IN",
      label: "India",
      phone: "91",
      nickname: "The Subcontinent",
    },
    {
      code: "IO",
      label: "British Indian Ocean Territory",
      phone: "246",
      nickname: "BIOT",
    },
    {
      code: "IQ",
      label: "Iraq",
      phone: "964",
      nickname: "Mesopotamia",
    },
    {
      code: "IR",
      label: "Iran",
      phone: "98",
      nickname: "Land of the Aryans",
    },
    {
      code: "IS",
      label: "Iceland",
      phone: "354",
      nickname: "The Land of Fire and Ice",
    },
    {
      code: "IT",
      label: "Italy",
      phone: "39",
      nickname: "The Boot",
    },
    {
      code: "JE",
      label: "Jersey",
      phone: "44",
      nickname: "The Bailiwick of Jersey",
    },
    {
      code: "JM",
      label: "Jamaica",
      phone: "1876",
      nickname: "The Land of Wood and Water",
    },
    {
      code: "JO",
      label: "Jordan",
      phone: "962",
      nickname: "The Hashemite Kingdom",
    },
    {
      code: "JP",
      label: "Japan",
      phone: "81",
      nickname: "Land of the Rising Sun",
      suggested: true,
    },
    {
      code: "KE",
      label: "Kenya",
      phone: "254",
      nickname: "The Cradle of Humanity",
    },
    {
      code: "KG",
      label: "Kyrgyzstan",
      phone: "996",
      nickname: "The Land of Celestial Mountains",
    },
    {
      code: "KH",
      label: "Cambodia",
      phone: "855",
      nickname: "The Kingdom of Wonder",
    },
    {
      code: "KI",
      label: "Kiribati",
      phone: "686",
      nickname: "The Ocean Island",
    },
    {
      code: "KM",
      label: "Comoros",
      phone: "269",
      nickname: "The Perfume Islands",
    },
    {
      code: "KN",
      label: "Saint Kitts and Nevis",
      phone: "1869",
      nickname: "The Mother Colony of the West Indies",
    },
    {
      code: "KP",
      label: "Korea, Democratic People's Republic of",
      phone: "850",
      nickname: "North Korea",
    },
    {
      code: "KR",
      label: "Korea, Republic of",
      phone: "82",
      nickname: "South Korea",
    },
    {
      code: "KW",
      label: "Kuwait",
      phone: "965",
      nickname: "The City of the Future",
    },
    {
      code: "KY",
      label: "Cayman Islands",
      phone: "1345",
      nickname: "The Financial Haven",
    },
    {
      code: "KZ",
      label: "Kazakhstan",
      phone: "7",
      nickname: "The Land of the Great Steppe",
    },
    {
      code: "LA",
      label: "Lao People's Democratic Republic",
      phone: "856",
      nickname: "The Land of a Million Elephants",
    },
    {
      code: "LB",
      label: "Lebanon",
      phone: "961",
      nickname: "The Land of the Cedars",
    },
    {
      code: "LC",
      label: "Saint Lucia",
      phone: "1758",
      nickname: "The Helen of the West Indies",
    },
    {
      code: "LI",
      label: "Liechtenstein",
      phone: "423",
      nickname: "The Principality",
    },
    {
      code: "LK",
      label: "Sri Lanka",
      phone: "94",
      nickname: "The Pearl of the Indian Ocean",
    },
    {
      code: "LR",
      label: "Liberia",
      phone: "231",
      nickname: "The Lone Star",
    },
    {
      code: "LS",
      label: "Lesotho",
      phone: "266",
      nickname: "The Mountain Kingdom",
    },
    {
      code: "LT",
      label: "Lithuania",
      phone: "370",
      nickname: "The Land of the Storks",
    },
    {
      code: "LU",
      label: "Luxembourg",
      phone: "352",
      nickname: "The Grand Duchy",
    },
    {
      code: "LV",
      label: "Latvia",
      phone: "371",
      nickname: "The Land of Blue Lakes",
    },
    {
      code: "LY",
      label: "Libya",
      phone: "218",
      nickname: "The Desert Jewel",
    },
    {
      code: "MA",
      label: "Morocco",
      phone: "212",
      nickname: "The Kingdom of the West",
    },
    {
      code: "MC",
      label: "Monaco",
      phone: "377",
      nickname: "The Principality of Monaco",
    },
    {
      code: "MD",
      label: "Moldova, Republic of",
      phone: "373",
      nickname: "The Land of Wines",
    },
    {
      code: "ME",
      label: "Montenegro",
      phone: "382",
      nickname: "The Black Mountain",
    },
    {
      code: "MF",
      label: "Saint Martin (French part)",
      phone: "590",
      nickname: "The Friendly Island",
    },
    {
      code: "MG",
      label: "Madagascar",
      phone: "261",
      nickname: "The Red Island",
    },
    {
      code: "MH",
      label: "Marshall Islands",
      phone: "692",
      nickname: "The Land of the Atolls",
    },
    {
      code: "MK",
      label: "Macedonia, the Former Yugoslav Republic of",
      phone: "389",
      nickname: "The Cradle of Civilization",
    },
    {
      code: "ML",
      label: "Mali",
      phone: "223",
      nickname: "The Land of the Great River",
    },
    {
      code: "MM",
      label: "Myanmar",
      phone: "95",
      nickname: "The Golden Land",
    },
    {
      code: "MN",
      label: "Mongolia",
      phone: "976",
      nickname: "The Land of the Eternal Blue Sky",
    },
    {
      code: "MO",
      label: "Macao",
      phone: "853",
      nickname: "The Las Vegas of Asia",
    },
    {
      code: "MP",
      label: "Northern Mariana Islands",
      phone: "1670",
      nickname: "America’s Best Kept Secret",
    },
    {
      code: "MQ",
      label: "Martinique",
      phone: "596",
      nickname: "The Isle of Flowers",
    },
    {
      code: "MR",
      label: "Mauritania",
      phone: "222",
      nickname: "The Land of a Million Poets",
    },
    {
      code: "MS",
      label: "Montserrat",
      phone: "1664",
      nickname: "The Emerald Isle of the Caribbean",
    },
    {
      code: "MT",
      label: "Malta",
      phone: "356",
      nickname: "The Mediterranean Heart",
    },
    {
      code: "MU",
      label: "Mauritius",
      phone: "230",
      nickname: "The Paradise Island",
    },
    {
      code: "MV",
      label: "Maldives",
      phone: "960",
      nickname: "The Tropical Paradise",
    },
    {
      code: "MW",
      label: "Malawi",
      phone: "265",
      nickname: "The Warm Heart of Africa",
    },
    {
      code: "MX",
      label: "Mexico",
      phone: "52",
      nickname: "The Land of Enchantment",
    },
    {
      code: "MY",
      label: "Malaysia",
      phone: "60",
      nickname: "Truly Asia",
    },
    {
      code: "MZ",
      label: "Mozambique",
      phone: "258",
      nickname: "The Land of Smiles",
    },
    {
      code: "NA",
      label: "Namibia",
      phone: "264",
      nickname: "The Land of the Brave",
    },
    {
      code: "NC",
      label: "New Caledonia",
      phone: "687",
      nickname: "The Paris of the Pacific",
    },
    {
      code: "NE",
      label: "Niger",
      phone: "227",
      nickname: "The Gateway to the Sahara",
    },
    {
      code: "NF",
      label: "Norfolk Island",
      phone: "672",
      nickname: "The South Pacific Paradise",
    },
    {
      code: "NG",
      label: "Nigeria",
      phone: "234",
      nickname: "The Giant of Africa",
    },
    {
      code: "NI",
      label: "Nicaragua",
      phone: "505",
      nickname: "The Land of Lakes and Volcanoes",
    },
    {
      code: "NL",
      label: "Netherlands",
      phone: "31",
      nickname: "Holland",
    },
    {
      code: "NO",
      label: "Norway",
      phone: "47",
      nickname: "The Land of the Midnight Sun",
    },
    {
      code: "NP",
      label: "Nepal",
      phone: "977",
      nickname: "The Roof of the World",
    },
    {
      code: "NR",
      label: "Nauru",
      phone: "674",
      nickname: "Pleasant Island",
    },
    {
      code: "NU",
      label: "Niue",
      phone: "683",
      nickname: "The Rock of Polynesia",
    },
    {
      code: "NZ",
      label: "New Zealand",
      phone: "64",
      nickname: "The Land of the Long White Cloud",
    },
    {
      code: "OM",
      label: "Oman",
      phone: "968",
      nickname: "The Pearl of Arabia",
    },
    {
      code: "PA",
      label: "Panama",
      phone: "507",
      nickname: "The Bridge of the World",
    },
    {
      code: "PE",
      label: "Peru",
      phone: "51",
      nickname: "The Land of the Incas",
    },
    {
      code: "PF",
      label: "French Polynesia",
      phone: "689",
      nickname: "Tahiti",
    },
    {
      code: "PG",
      label: "Papua New Guinea",
      phone: "675",
      nickname: "The Land of a Thousand Cultures",
    },
    {
      code: "PH",
      label: "Philippines",
      phone: "63",
      nickname: "The Pearl of the Orient Seas",
    },
    {
      code: "PK",
      label: "Pakistan",
      phone: "92",
      nickname: "The Land of the Pure",
    },
    {
      code: "PL",
      label: "Poland",
      phone: "48",
      nickname: "The Land of Fields",
    },
    {
      code: "PM",
      label: "Saint Pierre and Miquelon",
      phone: "508",
      nickname: "France in North America",
    },
    {
      code: "PN",
      label: "Pitcairn",
      phone: "870",
      nickname: "The Island of Mutineers",
    },
    {
      code: "PR",
      label: "Puerto Rico",
      phone: "1",
      nickname: "The Isle of Enchantment",
    },
    {
      code: "PS",
      label: "Palestine, State of",
      phone: "970",
      nickname: "The Holy Land",
    },
    {
      code: "PT",
      label: "Portugal",
      phone: "351",
      nickname: "The Land of Navigators",
    },
    {
      code: "PW",
      label: "Palau",
      phone: "680",
      nickname: "The Rainbow’s End",
    },
    {
      code: "PY",
      label: "Paraguay",
      phone: "595",
      nickname: "The Heart of South America",
    },
    {
      code: "QA",
      label: "Qatar",
      phone: "974",
      nickname: "The Richest Country",
    },
    {
      code: "RE",
      label: "Reunion",
      phone: "262",
      nickname: "The Intense Island",
    },
    {
      code: "RO",
      label: "Romania",
      phone: "40",
      nickname: "The Carpathian Garden",
    },
    {
      code: "RS",
      label: "Serbia",
      phone: "381",
      nickname: "The Land of the Eagles",
    },
    {
      code: "RU",
      label: "Russian Federation",
      phone: "7",
      nickname: "The Bear of Eurasia",
    },
    {
      code: "RW",
      label: "Rwanda",
      phone: "250",
      nickname: "The Land of a Thousand Hills",
    },
    {
      code: "SA",
      label: "Saudi Arabia",
      phone: "966",
      nickname: "The Kingdom",
    },
    {
      code: "SB",
      label: "Solomon Islands",
      phone: "677",
      nickname: "The Happy Isles",
    },
    {
      code: "SC",
      label: "Seychelles",
      phone: "248",
      nickname: "The Land of Perpetual Summer",
    },
    {
      code: "SD",
      label: "Sudan",
      phone: "249",
      nickname: "The Gateway to Africa",
    },
    {
      code: "SE",
      label: "Sweden",
      phone: "46",
      nickname: "The Land of the Vikings",
    },
    {
      code: "SG",
      label: "Singapore",
      phone: "65",
      nickname: "The Lion City",
    },
    {
      code: "SH",
      label: "Saint Helena",
      phone: "290",
      nickname: "The Island of Exile",
    },
    {
      code: "SI",
      label: "Slovenia",
      phone: "386",
      nickname: "The Sunny Side of the Alps",
    },
    {
      code: "SJ",
      label: "Svalbard and Jan Mayen",
      phone: "47",
      nickname: "The Arctic Archipelago",
    },
    {
      code: "SK",
      label: "Slovakia",
      phone: "421",
      nickname: "The Heart of Europe",
    },
    {
      code: "SL",
      label: "Sierra Leone",
      phone: "232",
      nickname: "The Lion Mountains",
    },
    {
      code: "SM",
      label: "San Marino",
      phone: "378",
      nickname: "The Most Serene Republic",
    },
    {
      code: "SN",
      label: "Senegal",
      phone: "221",
      nickname: "The Land of Teranga",
    },
    {
      code: "SO",
      label: "Somalia",
      phone: "252",
      nickname: "The Horn of Africa",
    },
    {
      code: "SR",
      label: "Suriname",
      phone: "597",
      nickname: "The Land of Rivers",
    },
    {
      code: "SS",
      label: "South Sudan",
      phone: "211",
      nickname: "The Newest Nation",
    },
    {
      code: "ST",
      label: "Sao Tome and Principe",
      phone: "239",
      nickname: "The Land of Cocoa",
    },
    {
      code: "SV",
      label: "El Salvador",
      phone: "503",
      nickname: "The Land of Volcanoes",
    },
    {
      code: "SX",
      label: "Sint Maarten (Dutch part)",
      phone: "1721",
      nickname: "The Friendly Island",
    },
    {
      code: "SY",
      label: "Syrian Arab Republic",
      phone: "963",
      nickname: "The Cradle of Civilization",
    },
    {
      code: "SZ",
      label: "Swaziland",
      phone: "268",
      nickname: "The Kingdom of Eswatini",
    },
    {
      code: "TC",
      label: "Turks and Caicos Islands",
      phone: "1649",
      nickname: "Beautiful by Nature",
    },
    {
      code: "TD",
      label: "Chad",
      phone: "235",
      nickname: "The Babel Tower of the World",
    },
    {
      code: "TF",
      label: "French Southern Territories",
      phone: "262",
      nickname: "The Land of Penguins",
    },
    {
      code: "TG",
      label: "Togo",
      phone: "228",
      nickname: "The Land of Hospitality",
    },
    {
      code: "TH",
      label: "Thailand",
      phone: "66",
      nickname: "The Land of Smiles",
    },
    {
      code: "TJ",
      label: "Tajikistan",
      phone: "992",
      nickname: "The Roof of the World",
    },
    {
      code: "TK",
      label: "Tokelau",
      phone: "690",
      nickname: "The Remote Island",
    },
    {
      code: "TL",
      label: "Timor-Leste",
      phone: "670",
      nickname: "The Newest Country in Asia",
    },
    {
      code: "TM",
      label: "Turkmenistan",
      phone: "993",
      nickname: "The Land of the Turkmen",
    },
    {
      code: "TN",
      label: "Tunisia",
      phone: "216",
      nickname: "The Jewel of the Mediterranean",
    },
    {
      code: "TO",
      label: "Tonga",
      phone: "676",
      nickname: "The Friendly Islands",
    },
    {
      code: "TR",
      label: "Turkey",
      phone: "90",
      nickname: "The Land of Four Seasons",
    },
    {
      code: "TT",
      label: "Trinidad and Tobago",
      phone: "1868",
      nickname: "The Land of the Hummingbird",
    },
    {
      code: "TV",
      label: "Tuvalu",
      phone: "688",
      nickname: "The Sinking Paradise",
    },
    {
      code: "TW",
      label: "Taiwan",
      phone: "886",
      nickname: "Formosa",
    },
    {
      code: "TZ",
      label: "United Republic of Tanzania",
      phone: "255",
      nickname: "The Land of Kilimanjaro",
    },
    {
      code: "UA",
      label: "Ukraine",
      phone: "380",
      nickname: "The Breadbasket of Europe",
    },
    {
      code: "UG",
      label: "Uganda",
      phone: "256",
      nickname: "The Pearl of Africa",
    },
    {
      code: "US",
      label: "United States",
      phone: "1",
      nickname: "The Land of the Free",
      suggested: true,
    },
    {
      code: "UY",
      label: "Uruguay",
      phone: "598",
      nickname: "The Switzerland of the Americas",
    },
    {
      code: "UZ",
      label: "Uzbekistan",
      phone: "998",
      nickname: "The Crossroads of the Silk Road",
    },
    {
      code: "VA",
      label: "Holy See (Vatican City State)",
      phone: "379",
      nickname: "The Vatican",
    },
    {
      code: "VC",
      label: "Saint Vincent and the Grenadines",
      phone: "1784",
      nickname: "The Land of the Blessed",
    },
    {
      code: "VE",
      label: "Venezuela",
      phone: "58",
      nickname: "The Land of Grace",
    },
    {
      code: "VG",
      label: "British Virgin Islands",
      phone: "1284",
      nickname: "Nature’s Little Secrets",
    },
    {
      code: "VI",
      label: "US Virgin Islands",
      phone: "1340",
      nickname: "America’s Caribbean",
    },
    {
      code: "VN",
      label: "Vietnam",
      phone: "84",
      nickname: "The Land of the Blue Dragon",
    },
    {
      code: "VU",
      label: "Vanuatu",
      phone: "678",
      nickname: "The Land of Smiles",
    },
    {
      code: "WF",
      label: "Wallis and Futuna",
      phone: "681",
      nickname: "The Islands of Uvea and Futuna",
    },
    {
      code: "WS",
      label: "Samoa",
      phone: "685",
      nickname: "The Treasured Islands",
    },
    {
      code: "XK",
      label: "Kosovo",
      phone: "383",
      nickname: "The Youngest Nation in Europe",
    },
    {
      code: "YE",
      label: "Yemen",
      phone: "967",
      nickname: "The Land of Sheba",
    },
    {
      code: "YT",
      label: "Mayotte",
      phone: "262",
      nickname: "The Island of a Thousand Faces",
    },
    {
      code: "ZA",
      label: "South Africa",
      phone: "27",
      nickname: "The Rainbow Nation",
    },
    {
      code: "ZM",
      label: "Zambia",
      phone: "260",
      nickname: "The Real Africa",
    },
    {
      code: "ZW",
      label: "Zimbabwe",
      phone: "263",
      nickname: "The House of Stone",
    },
  ];